import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import ContentAddShetabCard from "./content";
import { useQuery } from "@tanstack/react-query";
import { fetchUserBankAccounts } from "@/api/user/home";
/**
 * AddShetabCard
 *
 * نمایش بخش مدیریت حساب‌های بانکی کاربر و امکان افزودن کارت شتاب جدید.
 *
 * ویژگی‌ها:
 * - نمایش عنوان و آیکون مربوط به مدیریت حساب بانکی
 * - واکشی کارت‌های بانکی کاربر با استفاده از useQuery
 * - ارسال کارت‌ها به کامپوننت ContentAddShetabCard برای نمایش و مدیریت
 *
 * @returns JSX.Element
 */

const AddShetabCard = () => {
  const { data: dataUserBankAccounts } = useQuery({
    queryKey: ["userBankAccounts-data"],
    queryFn: () => fetchUserBankAccounts(),
  });
  return (
    <StackKit direction={"column"} sx={{ width: "100%" }} gap={2}>
      <StackKit direction={"row"} sx={{ justifyContent:{sm:'start',xs:'center'},width: "100%", gap: "10px" }}>
        <AccountBalanceWalletOutlinedIcon sx={{ color: "#fff", ml: "0px" }} />
        <TypoGraphyKit sx={{ ml: "0 !important" }} variant="h6">
          مدیریت حساب بانکی
        </TypoGraphyKit>
      </StackKit>
      <ContentAddShetabCard dataUserBankAccounts={dataUserBankAccounts} />
    </StackKit>
  );
};

export default AddShetabCard;
